import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-bold-clock',
    imports: [],
    templateUrl: './icon-bold-clock.html',
    styleUrl: './icon-bold-clock.css'
})
export class IconBoldClock {
    @Input() color: string = 'currentColor';
    @Input() size: string = '24px';
}
